export let rule_selector = function() {
    let ret = [];
    Object.keys(rule_settings).map(function(key) {
        ret.push({
            clearableValue:false,
            label:rule_settings[key].text,
            value:key,
        })
    });

    return ret;
}

const stand_alone_error = "This rule can't be used alone. It needs to be combined with a rule that does more visitor filtering.";

export let operator_selector = function(current_key) {
    let ret = [];

    let available = rule_settings[current_key]['operators'];

    Object.keys(available).map(function(key) {
        ret.push({
            clearableValue:false,
            label:available[key],
            value:key,
        })
    });

    return ret;
}

export const operators = {
    '==': {
        text: 'equals',
    },
    '!=': {
        text: 'not equals',
    },
    '>=': {
        text: 'greater than',
    },
    '<=': {
        text: 'less than',
    },
    '%%': {
        text: 'contains',
    },
};

const str = {
    eq:'equals',
    neq:'not equals',
    gt:'greater or equal to',
    lt:'less or equal to',
    c:'contains',
}

export const rule_settings = {
    'BoughtFromCategory': {
        text:'Has/Has not Bought from Category',
        operators: {
            '==': 'has bought',
            '!=': 'has not bought',
        },
        value_type:'CategoryPicker',
        relative_text:'Customer must have bought item(s) %days% ago',
        date_range:true,
        has_relative:true,
        has_and:true,
        hide_and_rule:true,
        stand_alone:true,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one category";
            }

            return true;
        }

    },
    'BoughtManufacturer': {
        text:'Has/Has not Bought Manufacturer',
        operators: {
            '==': 'has bought',
            '!=': 'has not bought',
        },
        value_type:'ManufacturerPicker',
        relative_text:'Customer must have bought item(s) %days% ago',
        date_range:true,
        has_relative:true,
        has_and:true,
        hide_and_rule:true,
        stand_alone:true,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(rule.value == false || rule.value == '' || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one manufacturer";
            }

            return true;
        }
    },

    'BoughtProduct': {
        text:'Has/Has not Bought Product',
        operators: {
            '==': 'has bought',
            '!=': 'has not bought',
        },
        value_type:'ProductPicker',
        relative_text:'Customer must have bought item(s) %days% ago',
        date_range:true,
        has_relative:true,
        has_and:true,
        hide_and_rule:true,
        stand_alone:true,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one product";
            }

            return true;
        }
    },

    'BrowsedCategory': {
        text:'Has browsed Category',
        operators: {
            '==': 'has browsed',
        },
        value_type:'CategoryPicker',
        relative_text:'Customer has browsed category %days% ago',
        date_range:true,
        has_relative:true,
        has_and:true,
        stand_alone:false,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one category";
            }

            if(!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'BrowsedProduct': {
        text:'Has seen Product',
        operators: {
            '==': 'has seen',
        },
        value_type:'ProductPicker',
        relative_text:'Customer has seen product(s) %days% ago',
        date_range:true,
        has_relative:true,
        has_and:true,
        stand_alone:false,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one product";
            }

            if(!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'PopupSubscriber': {
        text:'Subscribed to popup',
        operators: {
            '==': 'is subscribing to',
        },
        value_type:'PopupPicker',
        date_range:false,
        has_relative:false,
        has_and:false,
        stand_alone:true,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(rule.value == false || rule.value == 'false' || !rule.value || rule.value.length <= 0) {
                return "You must specify at least one popup";
            }

            if(!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'LastOrder': {
        text:'Last order order placed',
        operators: {
            '>=':'for more than',
        },
        value_type:'DayPicker',
        date_range:false,
        has_and:false,
        stand_alone:true,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(parseInt(rule.value) <= 0 || !rule.value) {
                return 'Sum must be more than zero';
            }

            return true;
        }
    },

    'LastSeen': {
        text:'Last seen in store',
        operators: {
            '>=':'for more than',
        },
        value_type:'DayPicker',
        date_range:false,
        has_and:false,
        stand_alone:true,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'Sessions': {
        text:'Number of store sessions is',
        operators: {
            '==':str.eq,
            '>=':str.gt,
            '<=':str.lt,
        },
        value_type:'NumberPicker',
        date_range:false,
        has_and:false,
        stand_alone:false,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'Age': {
        text:'Customers age is',
        operators: {
            '<=':'younger than',
            '>=':'older than',
        },
        value_type:'NumberPicker',
        date_range:false,
        has_and:false,
        stand_alone:false,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'Gender': {
        text:'Customers gender is',
        operators: {
            '==':'equal to',
        },
        value_type:'GenderPicker',
        date_range:false,
        has_and:false,
        stand_alone:false,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(!hasStandAlonerule(rules)) {
                return stand_alone_error;
            }

            return true;
        }
    },

    'OrderSum': {
        text:'Total generated order sum is',
        operators: {
            '==':str.eq,
            '!=':str.neq,
            '>=':str.gt,
            '<=':str.lt,
        },
        value_type:'NumberPicker',
        date_range:true,
        has_and:false,
        stand_alone:true,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }

            if(parseInt(rule.value) <= 0 || !rule.value) {
                return 'Sum must be more than zero';
            }

            return true;
        }
    },

    'OrderCount': {
        text:'Number of orders placed in store is',
        operators: {
            '==':str.eq,
            '!=':str.neq,
            '>=':str.gt,
            '<=':str.lt,
        },
        value_type:'NumberPicker',
        date_range:true,
        has_and:false,
        stand_alone:false,
        validate: function(rule,rules) {
            if(rule.operator == '' || !rule.operator || rule.operator == false || rule.operator == 'false') {
                return 'You must select a operator';
            }
            if(parseInt(rule.value) <= 0 && !hasStandAlonerule(rules)) {
                return stand_alone_error;
            }
            if(!rule.value && rule.value !== 0) {
                return 'Sum must be more than zero';
            }

            return true;
        }
    },
}

function hasStandAlonerule(rules) {
    let res = false;
    for(let i in rules) {
        if(rule_settings[rules[i].key].stand_alone === true) {
            res = true;
        }
    }

    return res;
}



// WEBPACK FOOTER //
// ./containers/segments/constants.js